import { useReducer } from 'react'

export const useToggle = (initialValue?: boolean) =>
  useReducer((open) => !open, initialValue ?? false)
